<template>
  <v-card class="px-4 py-3" @click="clickCard()" elevation="0" tile>
    <div class="primary--text text--accent-4" v-text="dateTime"></div>

    <div class="mt-1 black--text" v-html="title_zh + '<br>' + title_en"></div>

    <div class="mt-1 grey--text text--darken-1" v-text="location" v-if="$route.name !== 'Session'"></div>

    <slot name="action" v-bind:content="{ title: title_en, dateTime, location: track.name }"></slot>
  </v-card>
</template>

<script>
export default {
  name: "SessionCard",
  props: {
    hasLink: {
      type: Boolean,
      default: true
    },
    id: {
      type: Number,
      required: true
    },
    title_zh: {
      type: String
    },
    title_en: {
      type: String
    },
    start_time: {
      type: String
    },
    end_time: {
      type: String
    },
    track: {
      type: [Object, Number]
    }
  },
  data() {
    return {
      location: ""
    };
  },
  computed: {
    dateTime() {
      const date = this.$dayjs(this.start_time)
        .utc()
        .format("YYYY/MM/DD");

      const timeStart = this.$dayjs(this.start_time)
        .utc()
        .format("HH:mm");
      const timeEnd = this.$dayjs(this.end_time)
        .utc()
        .format("HH:mm");

      return (this.$route.name !== "Session" ? `${date} - ` : "") + `${timeStart} ~ ${timeEnd}`;
    }
  },
  methods: {
    clickCard() {
      if (this.hasLink) this.$router.push({ name: "Session", params: { id: this.id } });
    },
    async getLocation(track) {
      let trackName = null;
      if (typeof track === "number") {
        trackName = this.$store.getters.trackName(track);
      } else {
        trackName = track.name;
      }

      this.location = trackName;
    }
  },
  async mounted() {
    if (this.$route.name !== "Session") await this.getLocation(this.track);
  }
};
</script>

<style></style>
